var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.9093 0H8.45493V1.09094H1.9093V8.72751H0.818359V1.09094C0.818359 0.490922 1.30928 0 1.9093 0ZM4.09117 2.18188H10.0913C10.6914 2.18188 11.1823 2.6728 11.1823 3.27282V10.9094C11.1823 11.5094 10.6914 12.0003 10.0913 12.0003H4.09117C3.49116 12.0003 3.00024 11.5094 3.00024 10.9094V3.27282C3.00024 2.6728 3.49116 2.18188 4.09117 2.18188ZM4.09117 10.9094H10.0913V3.27282H4.09117V10.9094Z",
    fill: "#1F2937"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "8cc35fde6760ccca859a7a8cbb1fa01b.svg";
export { ForwardRef as ReactComponent };